import React from 'react';
import { loadable } from '../../services/loadable';

export default loadable(
  () => import(/* webpackChunkName: "member-card-async-frameless" */ '../member-card'),
  {
    loading: props => <div className={props.className}>{props.children}</div>,
  },
);
